import { render, staticRenderFns } from "./JAGFxDashboard.vue?vue&type=template&id=0d10639e&"
import script from "./JAGFxDashboard.vue?vue&type=script&lang=js&"
export * from "./JAGFxDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports